import React, { useEffect, useState } from 'react';
import SideNavClass from './SideNavClass';
import { isMobile } from 'react-device-detect';
import { MDBAlert, MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCol, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow } from 'mdb-react-ui-kit';
import CreateTrainer from '../../components/class/createTrainer';
import { deleteStaff, getStaffInfo, logEvent } from '../../services/classApiServices';
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics';
import { useAccess } from '../../context/AccessContext';


const ClassUsers = () => {
     const { trackButtonClick } = useAnalytics();
    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const [centredModal, setCentredModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [trainerid, setTrainerid] = useState(null);
    const [trainerData, setTrainerData] = useState([]);
    const [filteredTrainerData, setFilteredTrainerData] = useState([]);
    const [trainerInfo, setTrainerInfo] = useState(null);
    const [inputText, setInputText] = useState("");
    const [staffName, setStaffName] = useState("")
    const [Error2, setError2] = useState("")

    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("trainers")

    useEffect(() => {
        if (isMobile) {
            setModeOpen(false);
            setMode("over");
        }
    }, []);

    const sideNav = () => {
        setModeOpen(!modeOpen);
        setMode(isMobile ? "over" : "side");
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await getStaffInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") return;

            const trainerinfo = await response.json();
            console.log(trainerinfo, 'Trainer Info');
            setTrainerData(trainerinfo);
            setFilteredTrainerData(trainerinfo);
            setRefresh(false);
        };

        if (localStorage.getItem("loggedUserInfo")) {
            fetchData();
        }
    }, [refresh]);

    console.log(inputText);

    useEffect(() => {
        const filteredData = trainerData.filter((el) => {
            if (!inputText.trim()) return true;

            const searchValue = inputText.toLowerCase();
            const fullName = `${el.firstname || ''} ${el.lastname || ''}`.toLowerCase();

            return (
                el.firstname?.toLowerCase().includes(searchValue) ||
                el.lastname?.toLowerCase().includes(searchValue) ||
                el.number?.toLowerCase().includes(searchValue) ||
                el.email?.toLowerCase().includes(searchValue) ||
                fullName.includes(searchValue)
            );
        });

        setFilteredTrainerData(filteredData);
    }, [inputText, trainerData]);

    const handleEdit = (data) => {
        setTrainerInfo(data);
        setCentredModal(true);
    };

    const confirmDelete = async () => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const deletedStaffName = staffName.name?.trim()
            || `${staffName?.firstname || ""} ${staffName?.lastname || ""}`.trim()
            || staffName?.username
            || "-";

        try {
            await deleteStaff(trainerid);

            const flag = `Staff (${deletedStaffName}) deleted successfully`;
            setError2(flag);
            setRefresh(true);
            setDeleteModal(false);

            await logEvent(
                {
                    Eventtype: username1,
                    username1,
                    fullName,
                    ip,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true
                },
                gymid
            );
        await trackButtonClick("ClassUsers", "Delete_Trainer", "staff", {});


        } catch (error) {
            console.error("Failed to delete staff:", error);
        }
    };


    const handleDelete = (data) => {
        setStaffName(data)
        setTrainerid(data._id);
        setDeleteModal(true);
    };

    const handleSave = (flag) => {
        if (flag) {
            setError2(flag);
        }
        setRefresh(true);
        setTrainerInfo(null)
        setCentredModal(false);
    };

    const handlecancel = () => {
        setTrainerInfo(null)
        setCentredModal(false)
    }

    let staffRole = localStorage.getItem("loggedUserInfo")
        ? (JSON.parse(localStorage.getItem("loggedUserInfo")).role
            ? JSON.parse(localStorage.getItem("loggedUserInfo")).role : "admin") : "staff";


    const roleOptions = [
        { value: 1, label: 'Owner' },
        { value: 2, label: 'Manager' },
        { value: 3, label: 'Trainer' },
        { value: 4, label: 'FrontDesk' },
        { value: 5, label: 'Accountant' },
        { value: 6, label: 'CampaignManager' }
    ];

    return (
        <>
            <SideNavClass activeTab="ClassUsers" modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode}>

                {isMobile && <>
                    <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                        <div onClick={() => sideNav()} className='cursor-pointer'>
                            <MDBIcon fas icon='bars' size='lg' />
                        </div>
                        <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                    </header>
                </>}


                <MDBCard className="shadow-3 overflow-hidden">
                    <MDBCardBody className="custom-card-height">
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className="m-0">Trainers</h5>
                            {(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin" &&
                                <> <MDBBtn color="success" className="text-capitalize" onClick={() => setCentredModal(true)}>
                                    <MDBIcon fas icon="plus" className="me-2" />
                                    Add Trainer
                                </MDBBtn></>}
                        </div>

                        <div className="mt-4">
                            <MDBInput placeholder="Search Users..." onChange={(e) => setInputText(e.target.value)} />
                        </div>

                        <div className="mt-4">
                            <MDBRow className="cardInnerScroll" style={{ minHeight: '10vh' }}>
                                {filteredTrainerData.length > 0 ? (
                                    filteredTrainerData.map((user, index) => (
                                        <MDBCol key={user._id} md={4} lg={3} sm={12} className='mb-4 classUserCard'>
                                            <MDBCard className="custom-shadow">
                                                <MDBCardBody>
                                                    <div className="d-flex align-items-center justify-content-between pb-3">
                                                        <MDBCardTitle className="m-0">{user.firstname + " " + user.lastname}</MDBCardTitle>
                                                        <div className="d-flex align-items-center">
                                                            {roleAccess?.edittrainer == 1 || JSON.parse(localStorage.getItem("loggedUserInfo"))._id === user._id ? <div className="cursor-pointer" title="Edit" onClick={() => handleEdit(user)}>
                                                                <MDBIcon icon="edit" className="fs-6" />
                                                            </div> : <div className="cursor-pointer" title="Edit" >
                                                                {/* <MDBIcon icon="edit" className="fs-6" /> */}
                                                            </div>}
                                                            {roleAccess?.edittrainer == 1 || JSON.parse(localStorage.getItem("loggedUserInfo"))._id === user._id ? (
                                                                <div className="cursor-pointer ms-3" title="Delete" onClick={() => handleDelete(user)}>
                                                                    <MDBIcon icon="trash" className="fs-6" />
                                                                </div>
                                                            ) : (
                                                                <div className="cursor-pointer ms-3" title="Delete" >

                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <MDBCardText className="align-items-center d-flex" style={{ lineBreak: "anywhere" }}>
                                                        <MDBIcon far icon="envelope" className="me-2" size="lg" />
                                                        {user.email}
                                                    </MDBCardText>
                                                    <MDBCardText className="align-items-center d-flex">
                                                        <MDBIcon fas icon="phone-alt" className="me-2" size="lg" />
                                                        {user.number}
                                                    </MDBCardText>
                                                    <MDBCardText className="align-items-center d-flex">
                                                        <MDBIcon fas icon="key" className="me-2" size="lg" />
                                                        {/* {user.role} */}
                                                        {user?.rolevalues?.length > 0
                                                            ? roleOptions.length > 0
                                                                ? roleOptions
                                                                    .filter(option => user.rolevalues.includes(option.value))
                                                                    .map(option => option.label)
                                                                    .join(', ')
                                                                : "--"
                                                            : user.role || "--"
                                                        }
                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBCol>
                                    ))
                                ) : (
                                    <p className="text-center mt-4">No users found.</p>
                                )}
                            </MDBRow>
                        </div>
                    </MDBCardBody>
                </MDBCard>


                <MDBModal tabIndex="-1" open={centredModal} onClose={() => setCentredModal(false)}>
                    <MDBModalDialog centered size="lg">
                        <MDBModalContent>
                            <CreateTrainer ispopup="0" onSave={handleSave} onclose={handlecancel} trainerinfo={trainerInfo} />
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>


                <MDBModal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Are you sure you want to delete this class?</p>
                            </MDBModalBody>
                            <MDBModalFooter className="pe-2 pb-2">
                                <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>
                                    Cancel
                                </MDBBtn>
                                <MDBBtn color="danger" onClick={confirmDelete}>
                                    Delete
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
                <MDBAlert
                    color='success'
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={Error2 !== ""}
                    onClose={() => setError2("")}
                >
                    {Error2}
                </MDBAlert>
            </SideNavClass>
        </>
    );
};

export default ClassUsers;
